export enum ClassFormField {
  UrlSlug = "UrlSlug",
}
